<template>
  <div class="ResetPassword">
    <v-container fill-height class="mainBackG h-100 loginMain">
      <v-layout row wrap align-center>
        <v-flex class="text-xs-center" xs12 sm12 md12 lg4 style="margin:auto">
          <div class="Formcard align no-shadow card-r">
            <v-form row class="w-100">
              <v-flex xs12 md12 pt-0>
              <v-toolbar flat xs12 class="toolbar">
              <div class="btn-tool text-xs-right">
                <router-link to="`/login`" class="aBtn">
                  <v-icon class="textColor">keyboard_arrow_left</v-icon>
                </router-link>
              </div>
              <v-spacer></v-spacer>
              <v-toolbar-title>
                <h2 class="textColor text-xs-center title">Reset Password</h2>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>
            </v-toolbar>
              </v-flex>
            <v-alert
              v-if="resetpasswordResponse && resetpasswordMsg"
              :value="true"
              color="success"
              icon="check_circle"
              outline
            >{{resetpasswordMsg}}</v-alert>
            <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
            <v-alert
              v-if="!resetpasswordResponse && resetpasswordMsg"
              :value="true"
              color="error"
              icon="warning"
              outline
            >{{resetpasswordMsg}}</v-alert>
            <!--<v-flex xs12 md12 pt-0 pb-5>-->
              <!-- <img class = "logo" src="../../assets/logo.png"/>
              <h1 class="headline font-weight-medium">Reset password</h1>-->
            <!--</v-flex>-->
                <v-layout wrap class="logBD">
                  <!-- <v-flex xs12 md12 class="text-xs-right" py-0 my-0>
                  </v-flex>-->
                  <v-flex xs12 sm12>
                    <v-text-field
                      outline
                      label="Email"
                      v-model="email"
                      :rules="emailRules"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-text-field outline label="Password" type="password" v-model="password" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-text-field outline label="Retype Password" type="password" v-model="RetypePassword" required></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 pb-0>
                    <v-btn
                      class="btnM mainBackG card-r no-shadow"
                      color="white"

                      @click="reset"
                    >Confirm</v-btn>
                  </v-flex>
                </v-layout>
            </v-form>
          </div>
          <notifications group="error" position="top center"/>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ResetPassword",
  data: () => ({
    resetPassword: false,
    resetpasswordMsg: "",
    resetpasswordResponse: "",
    email: "",
    password: "",
    RetypePassword:"",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ]
  }),
  methods: {
    reset() {
      this.resetpasswordMsg = "";
      var finalPassword
      if(this.password==this.RetypePassword){
          var token=this.$route.params.token
          var data ={
              "email":this.email,
              "password":this.password,
              "password_confirmation":this.RetypePassword,
              "token":token
          }
          this.loading = true;
          this.$store.dispatch("resetPassword", data).then(
          response => {
            if (response.status == "ok") {
              this.resetpasswordMsg =
                "An email with a verification code was just sent to " + email;
              this.resetpasswordResponse = true;
              this.$notify({
                group: "success",
                type: "success",
                text: `Success Check your mail`
              });
              this.$router.push(`/login`);
            } else {
                // error => {
                this.resetpasswordMsg = "Check your Mail Address";
                this.resetpasswordResponse = false;
                this.$notify({
                  group: "error",
                  type: "error",
                  text: `Enter valid email`
                });
                // }
            }
          },
          error => {
            this.resetpasswordMsg = "Check your Mail Address";
            this.resetpasswordResponse = false;
            this.$notify({
              group: "error",
              type: "error",
              text: `Enter valid email`
            });
          }
        );
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }else{
        this.resetpasswordMsg="Check your password"
      }

    }
    // )
  },
  computed: {
    loading: loading => Store.state.loading
  }
};
</script>
<style>
  .align{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-box;
  }
  .Formcard{
    height: -webkit-fill-available!important;
  }
</style>




// WEBPACK FOOTER //
// src/components/auth/ResetPasswordForm.vue